import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/archive/')({ beforeLoad: () => { throw redirect({ to: '/archive/projects', replace: true }); } });
